// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file live178/v1/payment.proto (package live178.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Money, PageRequest, PageResponse } from "./common_pb";
import { file_live178_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file live178/v1/payment.proto.
 */
export const file_live178_v1_payment: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_live178_v1_common]);

/**
 * @generated from message live178.v1.WalletAccount
 */
export type WalletAccount = Message<"live178.v1.WalletAccount"> & {
  /**
   * @generated from field: string wallet_id = 1;
   */
  walletId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: live178.v1.Money available = 3;
   */
  available?: Money | undefined;

  /**
   * @generated from field: live178.v1.Money frozen = 4;
   */
  frozen?: Money | undefined;

  /**
   * @generated from field: live178.v1.Money total_recharge = 5;
   */
  totalRecharge?: Money | undefined;

  /**
   * @generated from field: live178.v1.Money total_withdraw = 6;
   */
  totalWithdraw?: Money | undefined;

  /**
   * @generated from field: int64 revision = 7;
   */
  revision: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.WalletAccount.
 * Use `create(WalletAccountSchema)` to create a new message.
 */
export const WalletAccountSchema: GenMessage<WalletAccount> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 0);

/**
 * @generated from message live178.v1.PaymentOrder
 */
export type PaymentOrder = Message<"live178.v1.PaymentOrder"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string order_number = 2;
   */
  orderNumber: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: live178.v1.PaymentChannel channel = 4;
   */
  channel: PaymentChannel;

  /**
   * @generated from field: live178.v1.Money amount = 5;
   */
  amount?: Money | undefined;

  /**
   * @generated from field: live178.v1.PaymentOrderStatus status = 6;
   */
  status: PaymentOrderStatus;

  /**
   * @generated from field: string channel_trade_number = 7;
   */
  channelTradeNumber: string;

  /**
   * @generated from field: string provider_payload = 8;
   */
  providerPayload: string;

  /**
   * @generated from field: google.protobuf.Timestamp paid_at = 9;
   */
  paidAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.PaymentOrder.
 * Use `create(PaymentOrderSchema)` to create a new message.
 */
export const PaymentOrderSchema: GenMessage<PaymentOrder> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 1);

/**
 * @generated from message live178.v1.WalletTransaction
 */
export type WalletTransaction = Message<"live178.v1.WalletTransaction"> & {
  /**
   * @generated from field: string transaction_id = 1;
   */
  transactionId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: live178.v1.WalletTransactionType type = 3;
   */
  type: WalletTransactionType;

  /**
   * @generated from field: live178.v1.Money amount = 4;
   */
  amount?: Money | undefined;

  /**
   * @generated from field: live178.v1.Money balance_after = 5;
   */
  balanceAfter?: Money | undefined;

  /**
   * @generated from field: string reference_type = 6;
   */
  referenceType: string;

  /**
   * @generated from field: string reference_id = 7;
   */
  referenceId: string;

  /**
   * @generated from field: string idempotency_key = 8;
   */
  idempotencyKey: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.WalletTransaction.
 * Use `create(WalletTransactionSchema)` to create a new message.
 */
export const WalletTransactionSchema: GenMessage<WalletTransaction> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 2);

/**
 * @generated from message live178.v1.Withdrawal
 */
export type Withdrawal = Message<"live178.v1.Withdrawal"> & {
  /**
   * @generated from field: string withdrawal_id = 1;
   */
  withdrawalId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: live178.v1.Money amount = 3;
   */
  amount?: Money | undefined;

  /**
   * @generated from field: string real_name_masked = 4;
   */
  realNameMasked: string;

  /**
   * @generated from field: string bank_account_masked = 5;
   */
  bankAccountMasked: string;

  /**
   * @generated from field: live178.v1.WithdrawalStatus status = 6;
   */
  status: WithdrawalStatus;

  /**
   * @generated from field: string first_reviewer_id = 7;
   */
  firstReviewerId: string;

  /**
   * @generated from field: string second_reviewer_id = 8;
   */
  secondReviewerId: string;

  /**
   * @generated from field: string review_remark = 9;
   */
  reviewRemark: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message live178.v1.Withdrawal.
 * Use `create(WithdrawalSchema)` to create a new message.
 */
export const WithdrawalSchema: GenMessage<Withdrawal> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 3);

/**
 * @generated from message live178.v1.PaymentAvailability
 */
export type PaymentAvailability = Message<"live178.v1.PaymentAvailability"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string disabled_message = 2;
   */
  disabledMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: int64 revision = 4;
   */
  revision: bigint;
};

/**
 * Describes the message live178.v1.PaymentAvailability.
 * Use `create(PaymentAvailabilitySchema)` to create a new message.
 */
export const PaymentAvailabilitySchema: GenMessage<PaymentAvailability> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 4);

/**
 * @generated from message live178.v1.GetPaymentAvailabilityRequest
 */
export type GetPaymentAvailabilityRequest = Message<"live178.v1.GetPaymentAvailabilityRequest"> & {
};

/**
 * Describes the message live178.v1.GetPaymentAvailabilityRequest.
 * Use `create(GetPaymentAvailabilityRequestSchema)` to create a new message.
 */
export const GetPaymentAvailabilityRequestSchema: GenMessage<GetPaymentAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 5);

/**
 * @generated from message live178.v1.GetPaymentAvailabilityResponse
 */
export type GetPaymentAvailabilityResponse = Message<"live178.v1.GetPaymentAvailabilityResponse"> & {
  /**
   * @generated from field: live178.v1.PaymentAvailability availability = 1;
   */
  availability?: PaymentAvailability | undefined;
};

/**
 * Describes the message live178.v1.GetPaymentAvailabilityResponse.
 * Use `create(GetPaymentAvailabilityResponseSchema)` to create a new message.
 */
export const GetPaymentAvailabilityResponseSchema: GenMessage<GetPaymentAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 6);

/**
 * @generated from message live178.v1.CreatePaymentOrderRequest
 */
export type CreatePaymentOrderRequest = Message<"live178.v1.CreatePaymentOrderRequest"> & {
  /**
   * @generated from field: live178.v1.PaymentChannel channel = 1;
   */
  channel: PaymentChannel;

  /**
   * @generated from field: live178.v1.Money amount = 2;
   */
  amount?: Money | undefined;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;

  /**
   * @generated from field: string return_url = 4;
   */
  returnUrl: string;
};

/**
 * Describes the message live178.v1.CreatePaymentOrderRequest.
 * Use `create(CreatePaymentOrderRequestSchema)` to create a new message.
 */
export const CreatePaymentOrderRequestSchema: GenMessage<CreatePaymentOrderRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 7);

/**
 * @generated from message live178.v1.CreatePaymentOrderResponse
 */
export type CreatePaymentOrderResponse = Message<"live178.v1.CreatePaymentOrderResponse"> & {
  /**
   * @generated from field: live178.v1.PaymentOrder order = 1;
   */
  order?: PaymentOrder | undefined;

  /**
   * @generated from field: string payment_payload = 2;
   */
  paymentPayload: string;
};

/**
 * Describes the message live178.v1.CreatePaymentOrderResponse.
 * Use `create(CreatePaymentOrderResponseSchema)` to create a new message.
 */
export const CreatePaymentOrderResponseSchema: GenMessage<CreatePaymentOrderResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 8);

/**
 * @generated from message live178.v1.HandlePaymentCallbackRequest
 */
export type HandlePaymentCallbackRequest = Message<"live178.v1.HandlePaymentCallbackRequest"> & {
  /**
   * @generated from field: live178.v1.PaymentChannel channel = 1;
   */
  channel: PaymentChannel;

  /**
   * @generated from field: string timestamp = 2;
   */
  timestamp: string;

  /**
   * @generated from field: string nonce = 3;
   */
  nonce: string;

  /**
   * @generated from field: bytes raw_payload = 4;
   */
  rawPayload: Uint8Array;

  /**
   * @generated from field: string signature = 5;
   */
  signature: string;
};

/**
 * Describes the message live178.v1.HandlePaymentCallbackRequest.
 * Use `create(HandlePaymentCallbackRequestSchema)` to create a new message.
 */
export const HandlePaymentCallbackRequestSchema: GenMessage<HandlePaymentCallbackRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 9);

/**
 * @generated from message live178.v1.HandlePaymentCallbackResponse
 */
export type HandlePaymentCallbackResponse = Message<"live178.v1.HandlePaymentCallbackResponse"> & {
  /**
   * @generated from field: live178.v1.PaymentOrder order = 1;
   */
  order?: PaymentOrder | undefined;

  /**
   * @generated from field: bool duplicate = 2;
   */
  duplicate: boolean;
};

/**
 * Describes the message live178.v1.HandlePaymentCallbackResponse.
 * Use `create(HandlePaymentCallbackResponseSchema)` to create a new message.
 */
export const HandlePaymentCallbackResponseSchema: GenMessage<HandlePaymentCallbackResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 10);

/**
 * @generated from message live178.v1.GetWalletRequest
 */
export type GetWalletRequest = Message<"live178.v1.GetWalletRequest"> & {
};

/**
 * Describes the message live178.v1.GetWalletRequest.
 * Use `create(GetWalletRequestSchema)` to create a new message.
 */
export const GetWalletRequestSchema: GenMessage<GetWalletRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 11);

/**
 * @generated from message live178.v1.GetWalletResponse
 */
export type GetWalletResponse = Message<"live178.v1.GetWalletResponse"> & {
  /**
   * @generated from field: live178.v1.WalletAccount wallet = 1;
   */
  wallet?: WalletAccount | undefined;
};

/**
 * Describes the message live178.v1.GetWalletResponse.
 * Use `create(GetWalletResponseSchema)` to create a new message.
 */
export const GetWalletResponseSchema: GenMessage<GetWalletResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 12);

/**
 * @generated from message live178.v1.ListWalletTransactionsRequest
 */
export type ListWalletTransactionsRequest = Message<"live178.v1.ListWalletTransactionsRequest"> & {
  /**
   * @generated from field: live178.v1.PageRequest page = 1;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListWalletTransactionsRequest.
 * Use `create(ListWalletTransactionsRequestSchema)` to create a new message.
 */
export const ListWalletTransactionsRequestSchema: GenMessage<ListWalletTransactionsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 13);

/**
 * @generated from message live178.v1.ListWalletTransactionsResponse
 */
export type ListWalletTransactionsResponse = Message<"live178.v1.ListWalletTransactionsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.WalletTransaction transactions = 1;
   */
  transactions: WalletTransaction[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListWalletTransactionsResponse.
 * Use `create(ListWalletTransactionsResponseSchema)` to create a new message.
 */
export const ListWalletTransactionsResponseSchema: GenMessage<ListWalletTransactionsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 14);

/**
 * @generated from message live178.v1.CreateWithdrawalRequest
 */
export type CreateWithdrawalRequest = Message<"live178.v1.CreateWithdrawalRequest"> & {
  /**
   * @generated from field: live178.v1.Money amount = 1;
   */
  amount?: Money | undefined;

  /**
   * @generated from field: string bank_account_token = 2;
   */
  bankAccountToken: string;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message live178.v1.CreateWithdrawalRequest.
 * Use `create(CreateWithdrawalRequestSchema)` to create a new message.
 */
export const CreateWithdrawalRequestSchema: GenMessage<CreateWithdrawalRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 15);

/**
 * @generated from message live178.v1.CreateWithdrawalResponse
 */
export type CreateWithdrawalResponse = Message<"live178.v1.CreateWithdrawalResponse"> & {
  /**
   * @generated from field: live178.v1.Withdrawal withdrawal = 1;
   */
  withdrawal?: Withdrawal | undefined;
};

/**
 * Describes the message live178.v1.CreateWithdrawalResponse.
 * Use `create(CreateWithdrawalResponseSchema)` to create a new message.
 */
export const CreateWithdrawalResponseSchema: GenMessage<CreateWithdrawalResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 16);

/**
 * @generated from message live178.v1.ListWithdrawalsRequest
 */
export type ListWithdrawalsRequest = Message<"live178.v1.ListWithdrawalsRequest"> & {
  /**
   * @generated from field: live178.v1.WithdrawalStatus status = 1;
   */
  status: WithdrawalStatus;

  /**
   * @generated from field: live178.v1.PageRequest page = 2;
   */
  page?: PageRequest | undefined;
};

/**
 * Describes the message live178.v1.ListWithdrawalsRequest.
 * Use `create(ListWithdrawalsRequestSchema)` to create a new message.
 */
export const ListWithdrawalsRequestSchema: GenMessage<ListWithdrawalsRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 17);

/**
 * @generated from message live178.v1.ListWithdrawalsResponse
 */
export type ListWithdrawalsResponse = Message<"live178.v1.ListWithdrawalsResponse"> & {
  /**
   * @generated from field: repeated live178.v1.Withdrawal withdrawals = 1;
   */
  withdrawals: Withdrawal[];

  /**
   * @generated from field: live178.v1.PageResponse page = 2;
   */
  page?: PageResponse | undefined;
};

/**
 * Describes the message live178.v1.ListWithdrawalsResponse.
 * Use `create(ListWithdrawalsResponseSchema)` to create a new message.
 */
export const ListWithdrawalsResponseSchema: GenMessage<ListWithdrawalsResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 18);

/**
 * @generated from message live178.v1.AuditWithdrawalRequest
 */
export type AuditWithdrawalRequest = Message<"live178.v1.AuditWithdrawalRequest"> & {
  /**
   * @generated from field: string withdrawal_id = 1;
   */
  withdrawalId: string;

  /**
   * @generated from field: live178.v1.WithdrawalDecision decision = 2;
   */
  decision: WithdrawalDecision;

  /**
   * @generated from field: string remark = 3;
   */
  remark: string;

  /**
   * @generated from field: string expected_revision = 4;
   */
  expectedRevision: string;
};

/**
 * Describes the message live178.v1.AuditWithdrawalRequest.
 * Use `create(AuditWithdrawalRequestSchema)` to create a new message.
 */
export const AuditWithdrawalRequestSchema: GenMessage<AuditWithdrawalRequest> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 19);

/**
 * @generated from message live178.v1.AuditWithdrawalResponse
 */
export type AuditWithdrawalResponse = Message<"live178.v1.AuditWithdrawalResponse"> & {
  /**
   * @generated from field: live178.v1.Withdrawal withdrawal = 1;
   */
  withdrawal?: Withdrawal | undefined;

  /**
   * @generated from field: bool second_approval_required = 2;
   */
  secondApprovalRequired: boolean;
};

/**
 * Describes the message live178.v1.AuditWithdrawalResponse.
 * Use `create(AuditWithdrawalResponseSchema)` to create a new message.
 */
export const AuditWithdrawalResponseSchema: GenMessage<AuditWithdrawalResponse> = /*@__PURE__*/
  messageDesc(file_live178_v1_payment, 20);

/**
 * @generated from enum live178.v1.PaymentChannel
 */
export enum PaymentChannel {
  /**
   * @generated from enum value: PAYMENT_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_CHANNEL_ALIPAY = 1;
   */
  ALIPAY = 1,

  /**
   * @generated from enum value: PAYMENT_CHANNEL_WECHAT = 2;
   */
  WECHAT = 2,

  /**
   * @generated from enum value: PAYMENT_CHANNEL_APPLE_IAP = 3;
   */
  APPLE_IAP = 3,
}

/**
 * Describes the enum live178.v1.PaymentChannel.
 */
export const PaymentChannelSchema: GenEnum<PaymentChannel> = /*@__PURE__*/
  enumDesc(file_live178_v1_payment, 0);

/**
 * @generated from enum live178.v1.PaymentOrderStatus
 */
export enum PaymentOrderStatus {
  /**
   * @generated from enum value: PAYMENT_ORDER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_ORDER_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PAYMENT_ORDER_STATUS_PAID = 2;
   */
  PAID = 2,

  /**
   * @generated from enum value: PAYMENT_ORDER_STATUS_FAILED = 3;
   */
  FAILED = 3,

  /**
   * @generated from enum value: PAYMENT_ORDER_STATUS_REFUNDED = 4;
   */
  REFUNDED = 4,
}

/**
 * Describes the enum live178.v1.PaymentOrderStatus.
 */
export const PaymentOrderStatusSchema: GenEnum<PaymentOrderStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_payment, 1);

/**
 * @generated from enum live178.v1.WithdrawalStatus
 */
export enum WithdrawalStatus {
  /**
   * @generated from enum value: WITHDRAWAL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WITHDRAWAL_STATUS_PENDING_REVIEW = 1;
   */
  PENDING_REVIEW = 1,

  /**
   * @generated from enum value: WITHDRAWAL_STATUS_PENDING_SECOND_APPROVAL = 2;
   */
  PENDING_SECOND_APPROVAL = 2,

  /**
   * @generated from enum value: WITHDRAWAL_STATUS_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: WITHDRAWAL_STATUS_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * @generated from enum value: WITHDRAWAL_STATUS_PAID = 5;
   */
  PAID = 5,

  /**
   * @generated from enum value: WITHDRAWAL_STATUS_FAILED = 6;
   */
  FAILED = 6,
}

/**
 * Describes the enum live178.v1.WithdrawalStatus.
 */
export const WithdrawalStatusSchema: GenEnum<WithdrawalStatus> = /*@__PURE__*/
  enumDesc(file_live178_v1_payment, 2);

/**
 * @generated from enum live178.v1.WalletTransactionType
 */
export enum WalletTransactionType {
  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_RECHARGE = 1;
   */
  RECHARGE = 1,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_GIFT_SENT = 2;
   */
  GIFT_SENT = 2,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_GIFT_RECEIVED = 3;
   */
  GIFT_RECEIVED = 3,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_WITHDRAWAL_FREEZE = 4;
   */
  WITHDRAWAL_FREEZE = 4,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_WITHDRAWAL_PAID = 5;
   */
  WITHDRAWAL_PAID = 5,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_WITHDRAWAL_RELEASE = 6;
   */
  WITHDRAWAL_RELEASE = 6,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_REFUND = 7;
   */
  REFUND = 7,

  /**
   * @generated from enum value: WALLET_TRANSACTION_TYPE_ADJUSTMENT = 8;
   */
  ADJUSTMENT = 8,
}

/**
 * Describes the enum live178.v1.WalletTransactionType.
 */
export const WalletTransactionTypeSchema: GenEnum<WalletTransactionType> = /*@__PURE__*/
  enumDesc(file_live178_v1_payment, 3);

/**
 * @generated from enum live178.v1.WithdrawalDecision
 */
export enum WithdrawalDecision {
  /**
   * @generated from enum value: WITHDRAWAL_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WITHDRAWAL_DECISION_APPROVE = 1;
   */
  APPROVE = 1,

  /**
   * @generated from enum value: WITHDRAWAL_DECISION_REJECT = 2;
   */
  REJECT = 2,
}

/**
 * Describes the enum live178.v1.WithdrawalDecision.
 */
export const WithdrawalDecisionSchema: GenEnum<WithdrawalDecision> = /*@__PURE__*/
  enumDesc(file_live178_v1_payment, 4);

/**
 * @generated from service live178.v1.PaymentService
 */
export const PaymentService: GenService<{
  /**
   * @generated from rpc live178.v1.PaymentService.GetPaymentAvailability
   */
  getPaymentAvailability: {
    methodKind: "unary";
    input: typeof GetPaymentAvailabilityRequestSchema;
    output: typeof GetPaymentAvailabilityResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.CreatePaymentOrder
   */
  createPaymentOrder: {
    methodKind: "unary";
    input: typeof CreatePaymentOrderRequestSchema;
    output: typeof CreatePaymentOrderResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.HandlePaymentCallback
   */
  handlePaymentCallback: {
    methodKind: "unary";
    input: typeof HandlePaymentCallbackRequestSchema;
    output: typeof HandlePaymentCallbackResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.GetWallet
   */
  getWallet: {
    methodKind: "unary";
    input: typeof GetWalletRequestSchema;
    output: typeof GetWalletResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.ListWalletTransactions
   */
  listWalletTransactions: {
    methodKind: "unary";
    input: typeof ListWalletTransactionsRequestSchema;
    output: typeof ListWalletTransactionsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.CreateWithdrawal
   */
  createWithdrawal: {
    methodKind: "unary";
    input: typeof CreateWithdrawalRequestSchema;
    output: typeof CreateWithdrawalResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.ListWithdrawals
   */
  listWithdrawals: {
    methodKind: "unary";
    input: typeof ListWithdrawalsRequestSchema;
    output: typeof ListWithdrawalsResponseSchema;
  },
  /**
   * @generated from rpc live178.v1.PaymentService.AuditWithdrawal
   */
  auditWithdrawal: {
    methodKind: "unary";
    input: typeof AuditWithdrawalRequestSchema;
    output: typeof AuditWithdrawalResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_live178_v1_payment, 0);

